import React, {Component} from 'react';
import {hasUserRight, showAxiosError} from "./helper/helper";
import {request} from "./helper/APIUtils";
import {Bar} from "react-chartjs-2";
import {Decimal} from 'decimal.js';
import {EntegratorConf, SERVLET_PATH, VirtualHost} from "./constants"
import moment from "moment";
import StickButton from "./components/StickButton";
import CreditHistoryModal from "./accounting/customer/components/CreditHistoryModal";
import SweetAlert from 'react-bootstrap-sweetalert';
import {Col, Row} from "reactstrap";
import PostpaidCustomerList from "./accounting/customer/components/PostpaidCustomerList";
import PayTrModal from "./accounting/paytr/PayTrModal";
import Select from "./local_node_modules/react-select"
import SmmmUserModal from "./accounting/smmmuserinformation/SmmmUserModal";
import CustomerRequiredFieldModal from "./accounting/smmmuserinformation/CustomerRequiredFieldModal";
import Swal from "sweetalert2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
    defterUnitName,
    show100000AsUnlimited,
    showAnnouncement,
    showBaro,
    showContactCard,
    showEdefterApplicationCard,
    showPaytrButton
} from "./helper/permission";
import {Modal} from "react-bootstrap";
import {UserRightsEnum} from "./helper/enums";
import EdefterApplicationModal from "./components/EdefterApplicationModal";
import Table from "./components/Table/Table";
import cacheInstance from './components/cache/Cache'
import IvdModal from "./faturam24/component/IvdModal";
import purify from "dompurify";
import {Image} from './common/Image';

class Faturam24HomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            creditHistoryModal: false,
            totalData: {
                labels: ['Ocak', 'Şubat', 'Mart', 'Nisan',
                    'Mayıs', 'Haziran', 'Temmuz', 'Ağustos',
                    'Eylül', 'Ekim', 'Kasım', 'Aralık'],
                datasets: [],
                redirect: false
            },
            endOfContractAlert: null,
            endingContracts: [],
            contentList: [],
            lastSgkInvoice: null,
            nextGocInvoice: null,
            showSmmInfoModal: false,
            showAnnouncementModal: false,
            showRequiredFiledModal: false,
            showMessage: false,
            currentYear: ((new Date().getMonth() === 0 && new Date().getDay() < 15) ? (new Date().getFullYear() - 1) : new Date().getFullYear()),
            callCenterModal: false,
            edefterApplicationModal: false,
            showCreditExpireModal: false,
            creditExpireList: [],
            selectedYear:new Date().getFullYear(),
            optionsYears:[],
            optionsCurrencyCode:null,
            selectedCurrencyCode: {label:"TL", value:"TRY"},
            thisYear:new Date().getFullYear(),
            day: '',
            month: '',
            y:'',
            ivdInfoModal: false
        };

        this.getCount = this.getCount.bind(this);
        this.onClickDetail = this.onClickDetail.bind(this);
        this.showCreditHistory = this.showCreditHistory.bind(this);
        this.closeCreditHistoryModal = this.closeCreditHistoryModal.bind(this);
        this.closeShowSmmInfoModal = this.closeShowSmmInfoModal.bind(this);
        this.closePostpaidCustomerListModal = this.closePostpaidCustomerListModal.bind(this);
        this.checkIfSmmm = this.checkIfSmmm.bind(this);
        this.checkInformation = this.checkInformation.bind(this);
        this.checkAnnouncement = this.checkAnnouncement.bind(this);
        this.checkCardAnnouncement = this.checkCardAnnouncement.bind(this);
        this.handleCloseCallCenterModal = this.handleCloseCallCenterModal.bind(this);
        this.openEdefterApplicationModal = this.openEdefterApplicationModal.bind(this);
        this.closeEdefterApplicationModal = this.closeEdefterApplicationModal.bind(this);
        this.checkCreditExpire = this.checkCreditExpire.bind(this);
        this.modifyDate = this.modifyDate.bind(this);
        this.startInitial = this.startInitial.bind(this);
        this.setValue = this.setValue.bind(this);
        this.checkIvdForFaturam24 = this.checkIvdForFaturam24.bind(this);
        this.closeIvdModal = this.closeIvdModal.bind(this);
    }

    lastSgkInvoice = (year) => {
        let prefix = "SGK";
        request({
            url: `/invoiceTmp/next-invoice?year=${year}&prefix=${prefix}&prefixCodeType=PrefixCode`,
            method: "get",
        }).then(response => {
            this.setState({lastSgkInvoice: response.data});
        }).catch(error => {
            showAxiosError(error);
        });
    };

    nextGocInvoice = (year) => {
        let prefix = "GOC";
        request({
            url: `/invoiceTmp/next-invoice?year=${year}&prefix=${prefix}&prefixCodeType=PrefixCode`,
            method: "get",
        }).then(response => {
            this.setState({nextGocInvoice: response.data});
        }).catch(error => {
            showAxiosError(error);
        });
    };

    activeYears = [
        {value: new Date().getFullYear(), label: new Date().getFullYear()},
        {value: (new Date().getFullYear() - 1), label: (new Date().getFullYear() - 1)},
    ];

    componentDidMount() {
        let self = this;
        let currentYear = self.state.currentYear;
        let thisYear = self.state.thisYear;
        let optionsYears = [
            {label:(thisYear-1).toString(), value:thisYear-1},
            {label:(thisYear).toString(), value:thisYear}
        ];
        let optionsCurrencyCode = [
            {label:"TL", value:"TRY"},
            {label:"USD", value:"USD"},
            {label:"EUR", value:"EUR"}
        ];
        this.setState({optionsYears,selectedYear:currentYear,thisYear,optionsCurrencyCode});
        this.startInitial();

        let d = new Date();
        let day = d.getUTCDate()-1;
        let month = d.getMonth() +1 ;
        let y = d.getUTCFullYear();

        this.setState({day: day <=9 ? '0' + day : day,
            month: month <=9 ? '0' + month : month,
            y: y});
    }

    startInitial(){
        let self = this;

        if (showPaytrButton(self.props.currentUser.parentCustomerWorkType, EntegratorConf.identifier) || VirtualHost.conf.resourcePrefix === "musavir") {
            self.checkInformation();
            if (["eczacikart", "togb"].includes(VirtualHost.conf.resourcePrefix))
                self.checkIfSmmm();
        }

        if (self.isEFatura()) {
            if (hasUserRight(UserRightsEnum.invoice.viewIncoming, this.props.currentUser))
                self.getCount("inbox");
            if (hasUserRight(UserRightsEnum.invoice.view, this.props.currentUser))
                self.getCount("outbox");
        }

        if (self.isEArsiv()) {
            if (hasUserRight(UserRightsEnum.earchive.view, this.props.currentUser))
                self.getCount("archive");
        }

        if (self.isEIrsaliye()) {
            if (hasUserRight(UserRightsEnum.despatch.viewIncoming, this.props.currentUser))
                self.getCount("despatchInbox");

            if (hasUserRight(UserRightsEnum.despatch.view, this.props.currentUser))
                self.getCount("despatchOutbox");
        }

        if (self.isEMM()) {
            if (hasUserRight(UserRightsEnum.voucher.mmView, this.props.currentUser))
                self.getCount("mVoucher");
        }

        if (self.isESMM()) {
            if (hasUserRight(UserRightsEnum.voucher.smmView, this.props.currentUser))
                self.getCount("sVoucher");
        }

        if(self.isEGiderPusulasi()){
            if(hasUserRight(UserRightsEnum.newExpenseNote.view, this.props.currentUser))
                self.getCount("expenseNote");
        }

        if (self.isEczaciKart() || self.isOgo()) {
            self.lastSgkInvoice(this.state.currentYear);
        }

        if (self.isEczaciKart()) {
            self.nextGocInvoice(this.state.currentYear);
        }

        if(self.isEBelge() && hasUserRight(UserRightsEnum.besbinotuzbin.view,this.props.currentUser)){
            self.getCount("ebelgeSend");
            self.getCount("ebelgeIn");
        }

        self.getCount("currency");
        self.getCount("credit");
        self.getCount("memory");
        self.getCount("fieldCredit");

        if (showAnnouncement()) {
            if (!this.props.currentUser.impersonate)
                self.checkAnnouncement();
            self.checkCardAnnouncement();
        }

        self.checkCreditExpire();
        self.checkIvdForFaturam24();
    }

    checkAnnouncement() {
        let resp;
        request({
            url: `/announcement/checkAnnouncement`,
            method: 'post'
        }).then(response => {
            if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                resp = response;

                let announcemetList = [];
                resp.data.map(ar => (
                    announcemetList.push({
                        title: '',
                        html: ar.contentResult,
                        text: ar.contentResult,
                        type: '',
                        animation: false,
                        width: "43rem",
                        allowOutsideClick: false,
                        allowEnterKey: false,
                        confirmButtonText: "Kapat( " + ar.remainingShow + " )",
                        padding: "0.80rem",
                        reverseButtons: true
                    })
                ));

                Swal.queue(announcemetList).then((result) => {
                    let count = "";
                    let requestData = [];
                    if (result.dismiss === Swal.DismissReason.cancel) {
                        resp.data.map(r => (
                            requestData.push({
                                'recordId': r.recordId,
                                'count': -1
                            })
                        ));
                    } else if (result.value && Array.isArray(result.value)) {
                        resp.data.map(r => (
                            requestData.push({
                                'recordId': r.recordId,
                                'count': 1
                            })
                        ));
                    }

                    if (requestData && Array.isArray(requestData)) {
                        request({
                            url: `/announcement/updateRemainingShowCount`,
                            method: 'post',
                            data: requestData
                        }).then(response => {
                            console.log(response);
                        }).catch(exception => {
                            console.log("updateRemainingShowCount - Exception", exception);
                        });
                    }
                }).catch(error => {
                    console.log("checkAnnouncement", error);
                });
            }
        }).catch(error => {
            console.log("checkAnnouncement", error);
        });
    }

    checkCardAnnouncement() {
        request({
            url: `/announcement/checkCardAnnouncement`,
            method: 'post'
        }).then(response => {
            if (response.data && response.data.contentList) {
                this.setState({contentList: response.data.contentList});
            }
        }).catch(error => {
            console.log("checkCardAnnouncement", error);
            //showAxiosError(error);
        });
    }

    checkIfSmmm() {
        request({
            url: `/smmmUserInformation/checkIfSmmm`,
            method: 'get'
        }).then(response => {
            if (response.data && response.data === true)
                this.setState({showSmmInfoModal: true});
        }).catch(error => {
            showAxiosError(error);
        });
    }

    checkInformation() {
        request({
            url: `/checkinformation/checkInformation`,
            method: 'post'
        }).then(response => {
            let requiredField = response.data;
            this.setState({showRequiredFiledModal: requiredField.status, requiredField});
        }).catch(error => {
            showAxiosError(error);
        });
    }

    getCount(type) {
        let self = this;
        let currencyCode = self.state.selectedCurrencyCode ? self.state.selectedCurrencyCode.value : "TRY";
        let data = {
            type: type,
            year: self.state.thisYear,
            currencyCode: currencyCode
        }

        let key = type + '-' + self.state.thisYear;

        let params = {
            url: `/homepage/infos`,
            method: "post",
            data: data
        };

        cacheInstance.get(key).then(responseObject => {
            if (responseObject) {
                self.setValue(type, responseObject);
            } else {
                request(params)
                    .then(response => {
                        if(response.data) {
                            self.setValue(type, response.data);
                            cacheInstance.set(key, response.data);
                        }
                    }).catch(function (error) {
                    showAxiosError(error);
                });
            }
        });
    }

    setValue(type, responseObject){
        let self = this;

        if (type === "inbox") {
            let inboxConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
            let tInboxConsumes = responseObject.inboxConsumes;
            for (let i = 0; i < tInboxConsumes.length; i++) {
                inboxConsumes[tInboxConsumes[i][1] - 1] = tInboxConsumes[i][0];
            }
            let totalData = self.state.totalData;
            totalData.datasets.push({
                label: 'Gelen Fatura Tutarı',
                type: "line",
                backgroundColor: 'rgba(255,99,132,0.2)',
                borderColor: 'rgba(255,99,132,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                hoverBorderColor: 'rgba(255,99,132,1)',
                data: inboxConsumes
            });
            self.setState({inboxCount: responseObject.inboxCount, totalData});
        } else if (type === "outbox") {
            let outboxConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
            let tOutboxConsumes = responseObject.outboxConsumes;
            for (let i = 0; i < tOutboxConsumes.length; i++) {
                outboxConsumes[tOutboxConsumes[i][1] - 1] = tOutboxConsumes[i][0];
            }
            let totalData = self.state.totalData;
            totalData.datasets.push({
                label: 'Giden Fatura Tutarı',
                type: "line",
                backgroundColor: 'rgba(105,231,129,0.2)',
                borderColor: 'rgba(105,231,129,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(105,231,129,0.4)',
                hoverBorderColor: 'rgba(105,231,129,1)',
                data: outboxConsumes
            });
            self.setState({outboxCount: responseObject.outboxCount, totalData});
        } else if (type === "archive") {
            let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
            let tArchiveConsumes = responseObject.archiveConsumes;
            for (let i = 0; i < tArchiveConsumes.length; i++) {
                archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
            }
            let totalData = self.state.totalData;
            totalData.datasets.push({
                label: 'E-Arşiv Fatura Tutarı',
                type: "line",
                backgroundColor: 'rgba(239,200,74,0.2)',
                borderColor: 'rgba(239,200,74,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(239,200,74,0.4)',
                hoverBorderColor: 'rgba(239,200,74,1)',
                data: archiveConsumes
            });
            self.setState({archiveCount: responseObject.archiveCount, totalData});
        } else if (type === "despatchInbox") {
            let inboxConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
            let tInboxConsumes = responseObject.despatchInboxConsumes;
            for (let i = 0; i < tInboxConsumes.length; i++) {
                inboxConsumes[tInboxConsumes[i][1] - 1] = tInboxConsumes[i][0];
            }
            let totalData = self.state.totalData;
            totalData.datasets.push({
                label: 'Gelen İrsaliye Tutarı',
                type: "line",
                backgroundColor: 'rgba(255,99,132,0.2)',
                borderColor: 'rgba(255,99,132,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                hoverBorderColor: 'rgba(255,99,132,1)',
                data: inboxConsumes
            });
            self.setState({despatchInboxCount: responseObject.despatchInboxCount, totalData});
        } else if (type === "despatchOutbox") {
            let outboxConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
            let tOutboxConsumes = responseObject.despatchOutboxConsumes;
            for (let i = 0; i < tOutboxConsumes.length; i++) {
                outboxConsumes[tOutboxConsumes[i][1] - 1] = tOutboxConsumes[i][0];
            }
            let totalData = self.state.totalData;
            totalData.datasets.push({
                label: 'Giden İrsaliye Tutarı',
                type: "line",
                backgroundColor: 'rgba(105,231,129,0.2)',
                borderColor: 'rgba(105,231,129,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(105,231,129,0.4)',
                hoverBorderColor: 'rgba(105,231,129,1)',
                data: outboxConsumes
            });
            self.setState({despatchOutboxCount: responseObject.despatchOutboxCount, totalData});
        } else if (type === "mVoucher") {
            let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
            let tArchiveConsumes = responseObject.mVoucherConsumes;
            for (let i = 0; i < tArchiveConsumes.length; i++) {
                archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
            }
            let totalData = self.state.totalData;
            totalData.datasets.push({
                label: 'Müstahsil Makbuz Tutarı',
                type: "line",
                backgroundColor: 'rgba(239,200,74,0.2)',
                borderColor: 'rgba(239,200,74,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(239,200,74,0.4)',
                hoverBorderColor: 'rgba(239,200,74,1)',
                data: archiveConsumes
            });
            self.setState({mVoucherCount: responseObject.mVoucherCount, totalData});
        } else if (type === "sVoucher") {
            let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
            let tArchiveConsumes = responseObject.sVoucherConsumes;
            for (let i = 0; i < tArchiveConsumes.length; i++) {
                archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
            }
            let totalData = self.state.totalData;
            totalData.datasets.push({
                label: 'Serbest Meslek Makbuz Tutarı',
                type: "line",
                backgroundColor: 'rgba(239,200,74,0.2)',
                borderColor: 'rgba(239,200,74,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(239,200,74,0.4)',
                hoverBorderColor: 'rgba(239,200,74,1)',
                data: archiveConsumes
            });
            self.setState({sVoucherCount: responseObject.sVoucherCount, totalData});
        }else if(type === "expenseNote"){
            let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
            let tArchiveConsumes = responseObject.expenseNoteConsumes;
            for (let i = 0; i < tArchiveConsumes.length; i++) {
                archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
            }
            let totalData = self.state.totalData;
            totalData.datasets.push({
                label: 'Gider Pusulası Tutarı',
                type: "line",
                backgroundColor: 'rgba(189,219,255,0.4)',
                borderColor: 'rgba(189,219,255,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(189,219,255,0.6)',
                hoverBorderColor: 'rgba(189,219,255,1)',
                data: archiveConsumes
            });
            self.setState({expenseNoteCount: responseObject.expenseNoteCount, totalData});
        } else if (type === "ebelgeSend") {
            let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
            let tArchiveConsumes = responseObject.ebelgeSendConsumes;
            for (let i = 0; i < tArchiveConsumes.length; i++) {
                archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
            }
            let totalData = self.state.totalData;
            totalData.datasets.push({
                label: 'Giden Fatura Tutarı',
                type: "line",
                backgroundColor: 'rgba(189,219,255,0.4)',
                borderColor: 'rgba(189,219,255,1)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(189,219,255,0.6)',
                hoverBorderColor: 'rgba(189,219,255,1)',
                data: archiveConsumes
            });
            self.setState({ebelgeCount: responseObject.ebelgeSendCount, totalData});
        } else if (type === "ebelgeIn") {
            let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
            let tArchiveConsumes = responseObject.ebelgeInboxConsumes;
            for (let i = 0; i < tArchiveConsumes.length; i++) {
                archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
            }
            let totalData = self.state.totalData;
            totalData.datasets.push({
                label: 'Gelen Fatura Tutarı',
                type: "line",
                backgroundColor: 'rgba(159,245,221,0.4)',
                borderColor: 'rgb(6,245,237)',
                borderWidth: 1,
                hoverBackgroundColor: 'rgba(189,219,255,0.6)',
                hoverBorderColor: 'rgba(189,219,255,1)',
                data: archiveConsumes
            });
            self.setState({ebelgeInCount: responseObject.ebelgeInboxCount, totalData});
        } else if (type === "currency") {
            self.setState({
                dollarCurrency: responseObject.dollarCurrency,
                euroCurrency: responseObject.euroCurrency
            });
        } else if (type === "credit") {
            let creditInfo = responseObject.creditInfo[0];
            let kalanCredit = (new Decimal((creditInfo[0] || 0)).sub(new Decimal((creditInfo[4] || 0))).toNumber());
            self.setState({
                totalLoadedCredit: creditInfo[0], kalanCredit: kalanCredit,
                showKontorYukleModal: (showPaytrButton(self.props.currentUser.parentCustomerWorkType, EntegratorConf.identifier)
                    && (self.withCredit() || self.isGarantiBankCustomer())
                    && (!creditInfo[0] || (creditInfo[0] - creditInfo[4] < 0)))
            });
        } else if (type === "memory") {
            let memoryInfo = responseObject.memoryInfo[0];
            let kalanMemory = (new Decimal((memoryInfo[0] || 0)).sub(new Decimal((memoryInfo[4] || 0))).toNumber());
            self.setState({totalLoadedMemory: memoryInfo[0], kalanMemory: kalanMemory});
        } else if (type === "fieldCredit") {
            let fieldCreditInfo = responseObject.fieldCreditInfo[0];
            let kalanFieldCredit = (new Decimal((fieldCreditInfo[0] || 0)).sub(new Decimal((fieldCreditInfo[4] || 0))).toNumber());
            self.setState({totalLoadedFieldCredit: fieldCreditInfo[0], kalanFieldCredit: kalanFieldCredit});
        } else {

        }

    }

    withCredit() {
        return this.props.currentUser && this.props.currentUser.withCredit;
    }

    isEFatura() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EFATURA;
    }

    isEArsiv() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EARSIV;
    }

    isEczaciKart() {
        return this.props.currentUser && VirtualHost.conf.resourcePrefix === "eczacikart";
    }

    isOgo() {
        return this.props.currentUser && VirtualHost.conf.resourcePrefix === "togb";
    }

    isSmart() {
        return this.props.currentUser && VirtualHost.conf.resourcePrefix === "smart";
    }

    isTdub() {
        return this.props.currentUser && VirtualHost.conf.resourcePrefix === "tdub";
    }

    isMusavir() {
        return this.props.currentUser && VirtualHost.conf.resourcePrefix === "musavir";
    }

    isKolaytest() {
        return this.props.currentUser && VirtualHost.conf.resourcePrefix === "kolaytest";
    }

    isKolaysoft() {
        return this.props.currentUser && VirtualHost.conf.resourcePrefix === "kolaysoft";
    }

    isEsmm() {
        return this.props.currentUser && VirtualHost.conf.resourcePrefix === "esmm";
    }

    isEGiderPusulasi(){
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EGIDERPUSULASI;
    }

    isTurcef() {
        return this.props.currentUser && VirtualHost.conf.resourcePrefix === "turcef";
    }

    isMedikal() {
        return this.props.currentUser && VirtualHost.conf.resourcePrefix === "medikal";
    }

    isIsitmeMerkezi() {
        return this.props.currentUser && VirtualHost.conf.resourcePrefix === "isitmemerkezi";
    }

    isTestud() {
        return this.props.currentUser && VirtualHost.conf.resourcePrefix === "testud";
    }

    isUstunBilgisayar() {
        return this.props.currentUser && VirtualHost.conf.resourcePrefix === "ustunbilgisayar";
    }

    isEIrsaliye() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EIRSALIYE;
    }

    isEMM() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EMM;
    }

    isESMM() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.ESMM;
    }

    isEDefter() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EDEFTER;
    }

    isEDefterSaklama() {
        return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EDEFTERSAKLAMA;
    }

    isGarantiBankCustomer() {
        //Garanti sayfasından mı oluşturuldu?
        return this.props.currentUser.parentCustomerId === 11119;
    }

    isEBelge() {
        return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EARSIVBESBINOTUZBIN;
    }

    onClickDetail(path) {
        this.props.history.push(path)
    }

    showCreditHistory() {
        this.setState({creditHistoryModal: true})
    }

    showPostpaidCustomerList() {
        this.setState({
            postpaidCustomerListModal: true,
        })
    }

    closeCreditHistoryModal() {
        this.setState({
            creditHistoryModal: false,
        })
    }

    closeShowSmmInfoModal() {
        this.setState({
            showSmmInfoModal: false
        })
    }

    closePostpaidCustomerListModal() {
        this.setState({
            postpaidCustomerListModal: false,
        })
    }

    isBaro() {
        let pref = this.props.currentUser && VirtualHost.conf.resourcePrefix;
        return pref === "ankarabarosu" || pref === "hataybarosu" || pref === "afyonbarosu" || pref === "nevsehirbarosu" || pref === "avukat" || pref === "zonguldakbarosu";
    }

    openCallCenterModal() {
        this.setState({
            callCenterModal: true
        })
    }

    handleCloseCallCenterModal() {
        this.setState({
            callCenterModal: false
        })
    }

    openEdefterApplicationModal() {
        this.setState({edefterApplicationModal: true});
    }

    closeEdefterApplicationModal() {
        this.setState({edefterApplicationModal: false});
    }

    refreshPage() {
        this.setState({edefterApplicationModal: false});
        window.location.reload();
    }

    checkCreditExpire() {
        request({
            url: "/credit/getExpireCredits",
            method: "get"
        }).then(response => {
            if (response && response.data)
                this.setState({creditExpireList: response.data, showCreditExpireModal: response.data.length > 0});
        }).catch(error => {
            console.log(error);
        });
    }

    modifyDate(date) {
        return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }

    setSelectYear(value){
        let self = this;
        let totalData = self.state.totalData;
        totalData.datasets=[]
        self.setState({thisYear:value,totalData },()=> this.startInitial());
    }

    handleSelectChange(field, value) {
        this.setState(prevState => {
            const updatedState = {
                [field]: value,
                totalData: {
                    ...prevState.totalData,
                    datasets: []
                }
            };
            const newState = { ...prevState, ...updatedState };
            return updatedState;
        }, () => {
            if (this.state.thisYear && this.state.selectedCurrencyCode) {
                this.startInitial();
            }
        });
    }

    checkIvdForFaturam24(){
        request({
            url: `/customer/checkIvdForFaturam24`,
            method: 'get'
        }).then(response => {
            if (!response.data)
                this.setState({ivdInfoModal: true, ivdInfoData: response.data});
        }).catch(error => {
            showAxiosError(error);
        });
    }

    closeIvdModal() {
        this.setState({
            ivdInfoModal: false
        });
    }

    render() {
        return !this.props.isAuthenticated ?
            <div></div> :
            (
                <Row style={{paddingTop: "22px"}}>
                    <Row>
                        <Col xs='12' lg='12'>
                            <Row>
                                <Col>
                                    <div className='pb-1'>
                                        <p id='dashboardInfo'><span>*</span> Ana sayfada gösterilen veriler düne ({this.state.day + '.' + this.state.month + '.' + this.state.y}) ait verilerdir. Gün sonunda güncellenecektir.</p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs='12' lg='4'>
                            <Row>
                                {this.isEFatura() && hasUserRight(UserRightsEnum.invoice.viewIncoming, this.props.currentUser) &&
                                <Col xs='12'>
                                    <div className="card lightgrey">
                                        <div className="col-md-12">
                                            <div className=" row"
                                                 style={{paddingTop: '10px', paddingBottom: '20px'}}>
                                                <div className="col-sm-6">
                                                    <label className='white' style={{
                                                        fontSize: '35px', fontWeight: 'bold',
                                                        marginBottom: '0px'
                                                    }}>{(this.state.inboxCount || this.state.inboxCount === 0) ? this.state.inboxCount : "..."}</label>
                                                    <h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
                                                        className="card-title white">
                                                        GELEN FATURALAR</h4>
                                                    <button className="TekBtn detay genislik"
                                                            onClick={(e) => this.onClickDetail("/eInvoiceInbox")}>
                                                        Detaylar
                                                    </button>
                                                </div>
                                                <div className="col-sm-6">
                                                    <Image className="sag simple-text logo-mini"
                                                         src={process.env.REACT_APP_CONTEXT_NAME + "/image/inbox2.png"}
                                                         style={{width: '85px', paddingTop: '20px'}}

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {(this.isEczaciKart()) &&
                                <Col xs='12'>
                                    <div className="card">
                                        <div className="">
                                            <div className=""></div>
                                            <div className="col-md-12">
                                                <Row>
                                                    <Col xs="12" style={{textAlign: 'center', padding: '8px'}}>
                                                        <Image src={process.env.REACT_APP_CONTEXT_NAME + "/image/goc-logo.png"}
                                                             style={{maxWidth: '35%'}}/>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col xs="12" style={{textAlign: 'center', padding: '2px'}}>
                                                        <Select name={"year"}
                                                                value={this.state.currentYear}
                                                                clearable={false}
                                                                onChange={e => {
                                                                    this.setState({currentYear: e.value});
                                                                    this.nextGocInvoice(e.value);
                                                                }}
                                                                options={this.activeYears}/>
                                                        <p style={{
                                                            fontSize: '15px',
                                                            color: '#468ae4',
                                                            margin: '0'
                                                        }}>Göç
                                                            İdaresi İçin Fatura Numarası</p>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col xs="12" style={{textAlign: 'center'}}>
                                                        <label style={{color: '#d43f00', fontSize: '25px'}}>
                                                            {(this.state.nextGocInvoice) ? this.state.nextGocInvoice : "..."}
                                                        </label>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {this.isEczaciKart() &&
                                <Col xs='12'>
                                    <div className="card">
                                        <div className="">
                                            <div className=""></div>
                                            <div className="col-md-12">
                                                <Row>
                                                    <Col xs="12" style={{textAlign: 'center', padding: '8px'}}>
                                                        <Image src={process.env.REACT_APP_CONTEXT_NAME + "/image/sgk-logo.png"}
                                                             style={{maxWidth: '35%'}}/>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col xs="12" style={{textAlign: 'center', padding: '2px'}}>
                                                        <Select name={"year"}
                                                                value={this.state.currentYear}
                                                                clearable={false}
                                                                onChange={e => {
                                                                    this.setState({currentYear: e.value});
                                                                    this.lastSgkInvoice(e.value);
                                                                }}
                                                                options={this.activeYears}/>
                                                        <p style={{
                                                            fontSize: '15px',
                                                            color: '#468ae4',
                                                            margin: '0'
                                                        }}>Medula {this.isOgo() ? "Optik" : "Eczane"} Döküm Listesi
                                                            İçin
                                                            Fatura Numarası</p>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col xs="12" style={{textAlign: 'center'}}>
                                                        <label style={{color: '#d43f00', fontSize: '25px'}}>
                                                            {(this.state.lastSgkInvoice) ? this.state.lastSgkInvoice : "..."}
                                                        </label>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {this.isEFatura() && hasUserRight(UserRightsEnum.invoice.view, this.props.currentUser) &&
                                <Col xs='12'>
                                    <div className={ VirtualHost.conf.resourcePrefix === 'esnaffatura' ? "card lightred" : "card lightblue"}>
                                        <div className="col-md-12">
                                            <div className="row"
                                                 style={{paddingTop: '10px', paddingBottom: '20px'}}>
                                                <div className="col-sm-6">
                                                    <label className='white' style={{
                                                        fontSize: '35px', fontWeight: 'bold',
                                                        marginBottom: '0px'
                                                    }}>{(this.state.outboxCount || this.state.outboxCount === 0) ? this.state.outboxCount : "..."}</label>
                                                    <h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
                                                        className="card-title white">
                                                        GİDEN FATURALAR</h4>
                                                    <button className="TekBtn detay genislik "
                                                            onClick={(e) => this.onClickDetail("/eInvoiceOutbox")}>
                                                        Detaylar
                                                    </button>
                                                </div>
                                                <div className="col-sm-6">
                                                    <Image className="sag simple-text logo-mini"
                                                         src={process.env.REACT_APP_CONTEXT_NAME + "/image/outbox2.png"}
                                                         style={{width: '85px', paddingTop: '20px'}}

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {this.isOgo() &&
                                <Col xs='12'>
                                    <div className="card">
                                        <div className="">
                                            <div className=""></div>
                                            <div className="col-md-12">
                                                <Row>
                                                    <Col xs="12" style={{textAlign: 'center', padding: '8px'}}>
                                                        <Image src={process.env.REACT_APP_CONTEXT_NAME + "/image/sgk-logo.png"}
                                                             style={{maxWidth: '35%'}}/>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col xs="12" style={{textAlign: 'center', padding: '2px'}}>
                                                        <Select name={"year"}
                                                                value={this.state.currentYear}
                                                                clearable={false}
                                                                onChange={e => {
                                                                    this.setState({currentYear: e.value});
                                                                    this.lastSgkInvoice(e.value);
                                                                }}
                                                                options={this.activeYears}/>
                                                        <p style={{
                                                            fontSize: '15px',
                                                            color: '#468ae4',
                                                            margin: '0'
                                                        }}>Medula {this.isOgo() ? "Optik" : "Eczane"} Döküm Listesi
                                                            İçin
                                                            Fatura Numarası</p>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col xs="12" style={{textAlign: 'center'}}>
                                                        <label style={{color: '#d43f00', fontSize: '25px'}}>
                                                            {(this.state.lastSgkInvoice) ? this.state.lastSgkInvoice : "..."}
                                                        </label>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {this.isEArsiv() && hasUserRight(UserRightsEnum.earchive.view, this.props.currentUser) &&
                                <Col xs='12'>
                                    <div className="card darkgrey">
                                        <div className="col-md-12">
                                            <div className="row"
                                                 style={{paddingTop: '10px', paddingBottom: '20px'}}>
                                                <div className="col-sm-6">
                                                    <label className='white' style={{
                                                        fontSize: '35px', fontWeight: 'bold',
                                                        marginBottom: '0px'
                                                    }}>{(this.state.archiveCount || this.state.archiveCount === 0) ? this.state.archiveCount : "..."}</label>
                                                    <h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
                                                        className="card-title white">
                                                        e-ARŞİV FATURALAR</h4>
                                                    <button className="TekBtn detay genislik"
                                                            onClick={(e) => this.onClickDetail("/eAInvoice")}>
                                                        Detaylar
                                                    </button>
                                                </div>
                                                <div className="col-sm-6">
                                                    <Image className=" sag simple-text logo-mini"
                                                         src={process.env.REACT_APP_CONTEXT_NAME + "/image/archive_count.png"}
                                                         style={{width: '85px', paddingTop: '20px'}}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {this.isEIrsaliye() && hasUserRight(UserRightsEnum.despatch.viewIncoming, this.props.currentUser) &&
                                <Col xs='12'>
                                    <div className="card lightgrey">
                                        <div className="col-md-12">
                                            <div className="row"
                                                 style={{paddingTop: '10px', paddingBottom: '20px'}}>
                                                <div className="col-sm-6">
                                                    <label className='white' style={{
                                                        fontSize: '35px', fontWeight: 'bold',
                                                        marginBottom: '0px'
                                                    }}>{(this.state.despatchInboxCount || this.state.despatchInboxCount === 0) ? this.state.despatchInboxCount : "..."}</label>
                                                    <h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
                                                        className="card-title white">
                                                        GELEN İRSALİYELER</h4>
                                                    <button className="TekBtn detay genislik"
                                                            onClick={(e) => this.onClickDetail("/eDespatchInbox")}>
                                                        Detaylar
                                                    </button>
                                                </div>
                                                <div className="col-sm-6">
                                                    <Image className=" sag simple-text logo-mini"
                                                         src={process.env.REACT_APP_CONTEXT_NAME + "/image/inbox2.png"}
                                                         style={{width: '85px', paddingTop: '20px'}}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {this.isEIrsaliye() && hasUserRight(UserRightsEnum.despatch.view, this.props.currentUser) &&
                                <Col xs='12'>
                                    <div className={ VirtualHost.conf.resourcePrefix === 'esnaffatura' ? "card lightred" : "card lightblue"}>
                                        <div className="col-md-12">
                                            <div className="row"
                                                 style={{paddingTop: '10px', paddingBottom: '20px'}}>
                                                <div className="col-sm-6">
                                                    <label className='white' style={{
                                                        fontSize: '35px', fontWeight: 'bold',
                                                        marginBottom: '0px'
                                                    }}>{(this.state.despatchOutboxCount || this.state.despatchOutboxCount === 0) ? this.state.despatchOutboxCount : "..."}</label>
                                                    <h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
                                                        className="card-title white">
                                                        GİDEN İRSALİYELER</h4>
                                                    <button className="TekBtn detay genislik"
                                                            onClick={(e) => this.onClickDetail("/eDespatchOutbox")}>
                                                        Detaylar
                                                    </button>
                                                </div>
                                                <div className="col-sm-6">
                                                    <Image className=" sag simple-text logo-mini"
                                                         src={process.env.REACT_APP_CONTEXT_NAME + "/image/outbox2.png"}
                                                         style={{width: '85px', paddingTop: '20px'}}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {this.isEMM() && hasUserRight(UserRightsEnum.voucher.mmView, this.props.currentUser) &&
                                <Col xs='12'>
                                    <div className="card darkgrey">
                                        <div className="col-md-12">
                                            <div className="row"
                                                 style={{paddingTop: '10px', paddingBottom: '20px'}}>
                                                <div className="col-sm-6">
                                                    <label className='white' style={{
                                                        fontSize: '35px', fontWeight: 'bold',
                                                        marginBottom: '0px'
                                                    }}>{(this.state.mVoucherCount || this.state.mVoucherCount === 0) ? this.state.mVoucherCount : "..."}</label>
                                                    <h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
                                                        className="card-title white">
                                                        e-MÜSTAHSİL MAKBUZLAR</h4>
                                                    <button className="TekBtn detay genislik"
                                                            onClick={(e) => this.onClickDetail("/eVoucherM")}>
                                                        Detaylar
                                                    </button>
                                                </div>
                                                <div className="col-sm-6">
                                                    <Image className="sag simple-text logo-mini"
                                                         src={process.env.REACT_APP_CONTEXT_NAME + "/image/archive_count.png"}
                                                         style={{width: '85px', paddingTop: '20px'}}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {this.isESMM() && hasUserRight(UserRightsEnum.voucher.smmView, this.props.currentUser) &&
                                <Col xs='12'>
                                    <div className="card lightgrey">
                                        <div className="col-md-12">
                                            <div className="row"
                                                 style={{paddingTop: '10px', paddingBottom: '20px'}}>
                                                <div className="col-sm-6">
                                                    <label className='white' style={{
                                                        fontSize: '35px', fontWeight: 'bold',
                                                        marginBottom: '0px'
                                                    }}>{(this.state.sVoucherCount || this.state.sVoucherCount === 0) ? this.state.sVoucherCount : "..."}</label>
                                                    <h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
                                                        className="card-title white">e-SERBEST MESLEK MAKBUZLAR</h4>
                                                    <button className="TekBtn detay genislik"
                                                            onClick={(e) => this.onClickDetail("/eVoucherS")}>
                                                        Detaylar
                                                    </button>
                                                </div>
                                                <div className="col-sm-6">
                                                    <Image className=" sag simple-text logo-mini"
                                                         src={process.env.REACT_APP_CONTEXT_NAME + "/image/archive_count.png"}
                                                         style={{width: '85px', paddingTop: '20px'}}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}
                                {
                                    this.isEGiderPusulasi() && hasUserRight(UserRightsEnum.newExpenseNote.view,this.props.currentUser) &&
                                    <Col xs='12'>
                                        <div className="card lightgrey">
                                            <div className="col-md-12">
                                                <div className="row" style={{paddingTop: '10px' , paddingBottom: '20px' }}>
                                                    <div className="col-sm-6">
                                                        <label className='white' style={{ fontSize: '35px' , fontWeight: 'bold' , marginBottom: '0px'
                                                        }}>{(this.state.expenseNoteCount || this.state.expenseNoteCount === 0) ?
                                                            this.state.expenseNoteCount : "..."}</label>
                                                        <h4 style={{fontFamily: 'Roboto' , fontSize: '1em' }} className="card-title white">e-GİDER PUSULASI</h4>
                                                        <button className="TekBtn detay genislik" onClick={(e)=> this.onClickDetail("/newExpenseNote")}>
                                                            Detaylar
                                                        </button>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <Image className=" sag simple-text logo-mini" src={process.env.REACT_APP_CONTEXT_NAME
                                                        + "/image/archive_count.png" } style={{width: '85px' , paddingTop: '20px' }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                }

                                {this.isEBelge() && this.props.currentUser && !this.props.currentUser.paidForFaturam24 &&
                                <Col xs='12'>
                                    <div className="card kolaygreen">
                                        <div className="col-md-12">
                                            <div className=" row"
                                                 style={{paddingTop: '10px', paddingBottom: '20px'}}>
                                                <div style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'space-around'
                                                }}>
                                                    <p style={{
                                                        fontSize: '2em',
                                                        fontFamily: 'Roboto',
                                                        // fontWeight: 'bold',
                                                        textAlign: 'center',
                                                        marginBottom: '0',
                                                        color: "white"
                                                    }}>Kredi Kartı ile Ödeme yapmak için&nbsp;
                                                        <a style={{
                                                            // color: "#2285C7",
                                                            textDecoration: "underline",
                                                            cursor: "pointer",
                                                            fontWeight: 'bold',
                                                        }}
                                                           onClick={() => this.setState({showPayTrModal: true})}>tıklayınız!</a>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {this.isEBelge() &&
                                <Col xs='12'>
                                    <div className="card kolayblue">
                                        <div className="col-md-12">
                                            <div className=" row"
                                                 style={{paddingTop: '10px', paddingBottom: '20px'}}>
                                                <div className="col-sm-6">
                                                    <label className='white' style={{
                                                        fontSize: '35px', fontWeight: 'bold',
                                                        marginBottom: '0px'
                                                    }}>{(this.state.ebelgeCount || this.state.ebelgeCount === 0) ? this.state.ebelgeCount : "..."}</label>
                                                    <h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
                                                        className="card-title white">
                                                        GİDEN FATURALAR</h4>
                                                    <button className="TekBtn detay genislik"
                                                            onClick={(e) => this.onClickDetail("/belgeSend")}>
                                                        Detaylar
                                                    </button>
                                                </div>
                                                <div className="col-sm-6">
                                                    <Image className="sag simple-text logo-mini"
                                                         src={process.env.REACT_APP_CONTEXT_NAME + "/image/outbox2.png"}
                                                         style={{width: '85px', paddingTop: '20px'}}

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {this.isEBelge() &&
                                <Col xs='12'>
                                    <div className="card kolaygreen">
                                        <div className="col-md-12">
                                            <div className=" row"
                                                 style={{paddingTop: '10px', paddingBottom: '20px'}}>
                                                <div className="col-sm-6">
                                                    <label className='white' style={{
                                                        fontSize: '35px', fontWeight: 'bold',
                                                        marginBottom: '0px'
                                                    }}>{(this.state.ebelgeInCount || this.state.ebelgeInCount === 0) ? this.state.ebelgeInCount : "..."}</label>
                                                    <h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
                                                        className="card-title white">
                                                        GELEN FATURALAR</h4>
                                                    <button className="TekBtn detay genislik"
                                                            onClick={(e) => this.onClickDetail("/belgeIn")}>
                                                        Detaylar
                                                    </button>
                                                </div>
                                                <div className="col-sm-6">
                                                    <Image className="sag simple-text logo-mini"
                                                         src={process.env.REACT_APP_CONTEXT_NAME + "/image/inbox2.png"}
                                                         style={{width: '85px', paddingTop: '20px'}}

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {(this.state.contentList && this.state.contentList.length > 0) &&
                                <Col xs='12'>
                                    <div className="card">
                                        <div className="">
                                            <div className="col-md-12">
                                                <div style={{paddingTop: "10px", paddingBottom: "5px"}}>
                                                    <Slider {...{
                                                        arrows: true,
                                                        adaptiveHeight: true,
                                                        cssEase: "linear",
                                                        dots: false,
                                                        infinite: true,
                                                        speed: 500,
                                                        slidesToShow: 1,
                                                        slidesToScroll: 1
                                                    }}>
                                                        {this.state.contentList.map((content, index) =>
                                                            <div>
                                                                <div dangerouslySetInnerHTML={{__html: purify.sanitize(content)}}/>
                                                            </div>
                                                        )}
                                                    </Slider>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {showContactCard() &&
                                <Col xs='12'>
                                    <div className=" card">
                                        <div className="col-xs-12" style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            height: '100%',
                                            justifyContent: 'space-evenly',
                                            padding: '5px 15px'
                                        }}>
                                            {!this.isUstunBilgisayar() && <i style={{
                                                position: 'absolute',
                                                top: '10px',
                                                right: '12px',
                                                fontSize: '20px',
                                                cursor: 'pointer',
                                                color: '#ff5757'
                                            }} className="far fa-question-circle"
                                                                             onClick={() => this.openCallCenterModal()}/>}
                                            <div style={{
                                                width: '100%',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'space-evenly',
                                                padding: '0 25px'
                                            }}>
                                                <div><i style={{fontSize: '30px', color: '#718ecf'}}
                                                        className="fas fa-headphones"/></div>
                                                <label style={{
                                                    fontSize: '20px',
                                                    color: '#f65b5b',
                                                    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
                                                    textTransform: 'uppercase'
                                                }}>Çağrı Merkezİ</label>
                                            </div>

                                            <div style={{
                                                width: '100%',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'space-around'
                                            }}>
                                                <p style={{
                                                    fontSize: '25px',
                                                    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
                                                    fontWeight: 'bold',
                                                    marginBottom: '0'
                                                }}>0850 307 7 724
                                                </p>
                                            </div>
                                            <div style={{
                                                width: '100%',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'space-around'
                                            }}>
                                                <p style={{
                                                    fontSize: '15px',
                                                    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
                                                    fontWeight: 'bold',
                                                    marginBottom: '0',
                                                }}>destek@faturam24.com
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {showEdefterApplicationCard(EntegratorConf.identifier) && this.isEFatura() && !this.isEDefter() &&
                                <Col xs='12'>
                                    <div className="card blink">
                                        <div className="col-xs-12" style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            height: '100%',
                                            justifyContent: 'space-evenly',
                                            padding: '5px 15px'
                                        }}>
                                            <div style={{
                                                width: '100%',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'space-evenly',
                                                padding: '0 25px'
                                            }}>
                                                <div><i style={{fontSize: '30px', color: '#718ecf'}}
                                                        className="fas fa-book"/></div>
                                                <label style={{
                                                    fontSize: '20px',
                                                    color: '#f65b5b',
                                                    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
                                                    textTransform: 'uppercase'
                                                }}>e-Defter Başvurusu</label>
                                            </div>

                                            <div style={{
                                                width: '100%',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'space-around'
                                            }}>
                                                <p style={{
                                                    fontSize: '14px',
                                                    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    marginBottom: '0'
                                                }}>e-Defter başvurunuzu yapmak için&nbsp;
                                                    <a style={{
                                                        color: "#f96332",
                                                        textDecoration: "none",
                                                        cursor: "pointer"
                                                    }}
                                                       onClick={() => this.openEdefterApplicationModal()}>tıklayınız!</a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}
                            </Row>
                        </Col>

                        <Col xs='12' lg='8'>
                            <Row>
                                {((this.isEFatura() && hasUserRight(UserRightsEnum.invoice.view, this.props.currentUser)) ||
                                    (this.isEArsiv() && hasUserRight(UserRightsEnum.earchive.view, this.props.currentUser)) ||
                                    (this.isEMM() && hasUserRight(UserRightsEnum.voucher.mmView, this.props.currentUser)) ||
                                    (this.isESMM() && hasUserRight(UserRightsEnum.voucher.smmView, this.props.currentUser)) ||
                                    this.isEBelge()) &&
                                <Col xs='12'>
                                    <div className={ VirtualHost.conf.resourcePrefix === 'esnaffatura' ? "card kolayred" : "card kolayblue"}>
                                        <div className="card-header white">
                                            <div className="row">
                                                <div className="col-6">
                                                    <h4 className="card-title white">AYLIK {(this.isEFatura() || this.isEArsiv() || this.isEBelge()) ? "FATURA" : "MAKBUZ"} TUTARI</h4>
                                                </div>
                                                <div className="col-6">
                                                    <div className="row d-flex justify-content-end">
                                                        <div className="col-sm-4">
                                                            <Select
                                                                className='selectpicker'
                                                                type='select'
                                                                value={this.state.thisYear}
                                                                clearable={false}
                                                                noResultsText="Veri yok"
                                                                clearValueText="Temizle"
                                                                placeholder="Seçiniz..."
                                                                onChange={(e) => this.handleSelectChange("thisYear", e.value)}
                                                                options={this.state.optionsYears}
                                                            />
                                                        </div>
                                                        <div className="col-sm-4">
                                                            <Select
                                                                className="selectpicker"
                                                                type="select"
                                                                value={this.state.selectedCurrencyCode ? this.state.selectedCurrencyCode : {
                                                                    label: "TL",
                                                                    value: "TRY"
                                                                }}
                                                                clearable={false}
                                                                noResultsText="Veri yok"
                                                                clearValueText="Temizle"
                                                                placeholder="Seçiniz..."
                                                                onChange={(e) => this.handleSelectChange("selectedCurrencyCode", e)}
                                                                options={this.state.optionsCurrencyCode}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="card-body white">
                                            <div className="col-md-12 row">
                                                <Bar data={this.state.totalData || {labels: []}}
                                                     width={100}
                                                     height={200}
                                                     options={{maintainAspectRatio: false}}/>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                {(this.isEFatura() || this.isEArsiv() || this.isEMM() || this.isESMM() || this.isEIrsaliye() || this.isEBelge()) &&
                                <Col xs='12' md='6'>
                                    <div className={ VirtualHost.conf.resourcePrefix === 'esnaffatura' ? "card kolayred" : "card kolayblue"}>
                                        <div className="card-header white">
                                            <h4 className="card-title white">KREDİ DURUMU</h4>
                                        </div>

                                        <div className="card-body white" style={{padding: '3px 15px 10px 15px'}}>
                                            <Row>
                                                <Col xs='12' md='6' style={{padding: '0 5px'}}>
                                                    <div className='credit-box'>
                                                        <div style={{width: '100%', background: '#d7d7d7'}}>
                                                            <label className='credit-box-header'>Kontör
                                                                Durumu</label>
                                                        </div>

                                                        <div>
                                                            <label className='credit-box-label'>Aktif Yük.
                                                                Kontör: </label>
                                                            <label className='credit-box-value'>{(this.state.totalLoadedCredit || this.state.totalLoadedCredit === 0) ? (this.state.totalLoadedCredit >= 100000 && show100000AsUnlimited(this.props.currentUser.parentCustomerId) ? "Sınırsız" : this.state.totalLoadedCredit) : "..."}</label>
                                                        </div>

                                                        <div>
                                                            <label className='credit-box-label'>Kontör
                                                                Durumu:</label>
                                                            <label className='credit-box-value'>
                                                                {
                                                                    (this.state.kalanCredit || this.state.kalanCredit === 0)
                                                                        ? (this.state.totalLoadedCredit >= 100000 && show100000AsUnlimited(this.props.currentUser.parentCustomerId)
                                                                        ? "Sınırsız"
                                                                        :
                                                                        (showBaro() ? this.state.totalLoadedCredit : this.state.kalanCredit))
                                                                        : "..."
                                                                }
                                                            </label>
                                                        </div>
                                                    </div>
                                                </Col>

                                                {(this.isEArsiv() && VirtualHost.conf.resourcePrefix === 'interpos') &&
                                                <Col xs='12' md='6'>
                                                    <div className='credit-box'>
                                                        <div style={{width: '100%', background: '#d7d7d7'}}>
                                                            <label className='credit-box-header'>Arşiv Kasa Kontör
                                                                Durumu</label>
                                                        </div>

                                                        <div>
                                                            <label className='credit-box-label'>Aktif Yük. Arşiv Kasa
                                                                Kontörü:</label>
                                                            <label className='credit-box-value'>{(this.state.totalLoadedFieldCredit || this.state.totalLoadedFieldCredit === 0) ? this.state.totalLoadedFieldCredit : "..."}</label>
                                                        </div>

                                                        <div>
                                                            <label className='credit-box-label'>Arşiv Kasa Kontör
                                                                Durumu:</label>
                                                            <label className='credit-box-value'>{(this.state.kalanFieldCredit || this.state.kalanFieldCredit === 0) ? this.state.kalanFieldCredit : "..."}</label>
                                                        </div>
                                                    </div>
                                                </Col>}

                                                <Col xs='12' style={{padding: '0 5px'}}>
                                                    {this.props.currentUser.adminUser &&
                                                    <div style={{
                                                        width: '100%',
                                                        display: 'flex',
                                                        flexDirection: 'row',
                                                        alignItems: 'center',
                                                        flexWrap: 'wrap'
                                                    }}>
                                                        <StickButton position="leftSide"
                                                                     label="Kredi Geçmişi"
                                                                     className='stickButton'
                                                                     labelClass='custom-label'
                                                                     onClick={() => this.showCreditHistory()}/>

                                                        {(this.props.currentUser.entegrator && this.props.currentUser.adminUser) &&
                                                        <StickButton position="leftSide"
                                                                     label="Faturalı Müşteriler"
                                                                     className='stickButton'
                                                                     labelClass='custom-label'
                                                                     onClick={() => this.showPostpaidCustomerList()}/>}

                                                        {showPaytrButton(this.props.currentUser.parentCustomerWorkType, EntegratorConf.identifier) &&
                                                        <StickButton position="leftSide"
                                                                     label="Ödeme Yap"
                                                                     className='stickButton'
                                                                     labelClass='custom-label'
                                                                     onClick={() => this.setState({showPayTrModal: true})}/>}
                                                    </div>}
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </Col>}

                                {((this.isEDefterSaklama() || this.isEDefter()) && !(this.isEFatura() || this.isEArsiv() || this.isEMM() || this.isESMM())) &&
                                <Col xs='12' md='6'>
                                    <div className={ VirtualHost.conf.resourcePrefix === 'esnaffatura' ? "card kolayred" : "card kolayblue"}>
                                        <div className="card-header white">
                                            <h4 className="card-title white">KALAN BAKİYENİZ</h4>
                                        </div>

                                        <div className="card-body" style={{padding: '3px 15px 10px 15px'}}>
                                            <hr style={{marginBottom: '10px', marginTop: '10px'}}></hr>
                                            <div className=" row">
                                                <div className="col-md-12">
                                                    <div className=" col-md-12 row" style={{float: 'left'}}>
                                                        <div className="col-sm-12">
                                                            <label style={{
                                                                fontSize: '16px',
                                                                fontWeight: 'bold',
                                                                whiteSpace: 'nowrap',
                                                                color:'white'
                                                            }}> {defterUnitName(EntegratorConf.identifier)} Durumu
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-12 ">
                                                            <label style={{fontSize: '13px', marginBottom: '5px',color:'white'}}>Aktif
                                                                Yük.
                                                                {defterUnitName(EntegratorConf.identifier)}: {(this.state.totalLoadedMemory || this.state.totalLoadedMemory === 0) ? this.state.totalLoadedMemory : "..."}</label>
                                                        </div>
                                                        <div className="col-sm-12 ">
                                                            <label style={{whiteSpace: 'nowrap',color:'white'}}>{defterUnitName(EntegratorConf.identifier)}
                                                                Durumu: {(this.state.kalanMemory || this.state.kalanMemory === 0) ? this.state.kalanMemory : "..."}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>}

                                <Col xs='12' md='6'>
                                    <div className={ VirtualHost.conf.resourcePrefix === 'esnaffatura' ? "card kolayred" : "card kolayblue"} style={{minHeight: '205px'}}>
                                        <div className="card-header white">
                                            <h4 className="card-title white">TCMB DÖVİZ KURLARI</h4>
                                        </div>

                                        <div className="card-body white">
                                            <Row>
                                                <div className="col-12 col-sm-12 row dovizContainer">
                                                    <div className="col-4 col-sm-4"></div>
                                                    <div className="col-4 col-sm-4 dovizUstBaslik">ALIŞ</div>
                                                    <div className="col-4 col-sm-4 dovizUstBaslik">SATIŞ</div>
                                                </div>
                                                <div className="col-12 col-sm-12 row dovizContainer">
                                                    <div className="col-4 col-sm-4 dovizYanBaslik">USD</div>
                                                    <div className="col-4 col-sm-4 dovizIcerik">
                                                        {(this.state.dollarCurrency && this.state.dollarCurrency.ForexBuying) ? this.state.dollarCurrency.ForexBuying : ""}₺
                                                    </div>
                                                    <div className="col-4 col-sm-4 dovizIcerik">
                                                        {(this.state.dollarCurrency && this.state.dollarCurrency.ForexSelling) ? this.state.dollarCurrency.ForexSelling : ""}₺
                                                    </div>
                                                </div>
                                                <div className="col-12 col-sm-12 row dovizContainer">
                                                    <div className="col-4 col-sm-4 dovizYanBaslik">EUR</div>
                                                    <div className="col-4 col-sm-4 dovizIcerik">
                                                        {(this.state.euroCurrency && this.state.euroCurrency.ForexBuying) ? this.state.euroCurrency.ForexBuying : ""}₺
                                                    </div>
                                                    <div className="col-4 col-sm-4 dovizIcerik">
                                                        {(this.state.euroCurrency && this.state.euroCurrency.ForexSelling) ? this.state.euroCurrency.ForexSelling : ""}₺
                                                    </div>
                                                </div>
                                            </Row>
                                        </div>
                                    </div>
                                </Col>

                                <Col xs='12'>
                                    <div className="card">
                                        <div className="card-header">
                                            {/*	<h4 className="card-title" style={{textTransform: 'uppercase'}}>{*/}
                                            {/*		VirtualHost.conf.resourcePrefix === "datakontrol" ?*/}
                                            {/*				"Ceo Programı yeni güncellemesi yayımlanmıştır. Detaylara aşağıdan ulaşabilirsiniz."*/}
                                            {/*				: "Yenİ Web Sayfamız Yayında"}*/}
                                            {/*	</h4>*/}
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <Image className="simple-text logo-mini"
                                                         onClick={() => setTimeout(function () {
                                                             window.open(VirtualHost.conf.webSiteUrl, "_blank");
                                                         }, 100)}
                                                         src={SERVLET_PATH + "/api/virtual/resource/web.png"}
                                                         style={{
                                                             width: '100%',
                                                             height: '100%', paddingTop: '0px'
                                                         }}

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    {(this.state.creditHistoryModal && this.props.currentUser.adminUser) &&
                    <CreditHistoryModal isOpen={this.state.creditHistoryModal}
                                        toggle={this.closeCreditHistoryModal}
                                        isEntegrator={this.props.isEntegrator}
                                        isDistributor={this.props.isDistributor}
                                        from="HomePage"
                                        currentUser={this.props.currentUser}/>
                    }
                    {this.state.showSmmInfoModal &&
                    <SmmmUserModal isOpen={this.state.showSmmInfoModal}
                                   toggle={this.closeShowSmmInfoModal}
                                   currentUser={this.props.currentUser}/>
                    }
                    {(this.state.showRequiredFiledModal && !this.props.currentUser.impersonate) &&
                    <CustomerRequiredFieldModal show={this.state.showRequiredFiledModal}
                                                requiredField={this.state.requiredField}
                                                toggle={() => this.setState({showRequiredFiledModal: false})}/>
                    }
                    {(this.state.showPayTrModal && this.props.currentUser.adminUser) &&
                    <PayTrModal show={this.state.showPayTrModal}
                                paytrDomain={this.props.currentUser.paytrDomain}
                                resourcePrefix={VirtualHost.conf.resourcePrefix}
                                parentCustomerId={this.props.currentUser.parentCustomerId}
                                isCreditUser={true}
                                isAreaUser={this.isEDefterSaklama() || this.isEDefter()}
                                toggle={() => this.setState({showPayTrModal: false})}/>
                    }
                    {this.state.showMessage &&
                    <SweetAlert warning
                                confirmBtnText="Tamam"
                                confirmBtnBsStyle="primary"
                                title="Duyuru"
                                onConfirm={() => this.setState({showMessage: false})}
                                onCancel={() => this.setState({showMessage: false})}
                    >
                        <p>Gelir İdaresi Başkanlığı bilgi işlem sistemlerinde 06/09/2021 Pazartesi
                            g&uuml;n&uuml; 00:00 ve 02:00 saatleri arası Planlı Bakım &Ccedil;alışması yapılacaktır. Bu s&uuml;re zarfında
                            g&ouml;nderim ve alım yapılamayacaktır.</p>
                        <p>T&uuml;m g&ouml;nderim işlemleriniz portal tarafından kuyruğa
                            alınıp &ccedil;alışma bittikten sonra g&ouml;nderilecektir.</p>
                        <p>Saygılarımızla</p>
                        <p><a href="https://ebelge.gib.gov.tr/dosyalar/PLANLI_BAKIM_CALISMASI_05092021.pdf">Duyuru Ayrıntısı için tıklayınız.</a></p>
                    </SweetAlert>
                    }

                    {(this.state.postpaidCustomerListModal) &&
                    <PostpaidCustomerList history={this.props.history}
                                          isOpen={this.state.postpaidCustomerListModal}
                                          toggle={this.closePostpaidCustomerListModal}/>
                    }
                    {this.state.ivdInfoModal &&
                    <IvdModal isOpen={this.state.ivdInfoModal}
                                           toggle={this.closeIvdModal}
                                           currentUser={this.props.currentUser}/>
                    }

                    <Modal show={this.state.callCenterModal} onHide={this.handleCloseCallCenterModal} size="lg">
                        <Modal.Header closeButton>
                            <h2 style={{marginBottom: '20px'}}>İLETİŞİM</h2>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}>
                                <div>
                                    <h4 style={{marginBottom: '5px'}}>Müşteri Hizmetleri</h4>
                                    <p>
                                        Telefon: 0850 307 7 724
                                        {this.isKolaysoft() && ' 0850 259 90 90'}
                                        {this.isBaro() && ' 0850 259 19 24'}
                                        {this.isEczaciKart() && ' 0850 259 98 08'}
                                        {this.isOgo() && ' 0850 259 96 06'}
                                        {this.isSmart() && ' 0850 259 93 93'}
                                        {this.isTdub() && ' 0850 259 90 90'}
                                        {this.isMusavir() && ' 0850 259 19 89'}
                                        {this.isEsmm() && ' 0850 259 90 90'}
                                        {this.isTurcef() && ' 0850 259 90 90'}
                                        {this.isMedikal() && '0850 259 90 90'}
                                        {this.isIsitmeMerkezi() && '0850 259 90 90'}
                                        {this.isTestud() && '0850 259 90 90'}

                                        {this.isKolaytest() && ' 0850 456 78 90'}
                                    </p>

                                    <h4 style={{marginBottom: '5px'}}>E-Posta Adresimiz (7/24 Online
                                        Destek)</h4>
                                    <p>
                                        İstek ve Talepleriniz İçin: destek@faturam24.com
                                        {this.isKolaysoft() && ' destek@kolaysoft.com.tr'}
                                        {this.isBaro() && ' avukat@kolaysoft.com.tr'}
                                        {this.isEczaciKart() && ' eczaci@kolaysoft.com.tr'}
                                        {this.isOgo() && ' destek@kolaysoft.com.tr'}
                                        {this.isSmart() && ' destek@smartdonusum.com'}
                                        {this.isTdub() && ' destek@kolaysoft.com.tr'}
                                        {this.isMusavir() && ' musavir@kolaysoft.com.tr'}
                                        {this.isEsmm() && ' destek@kolaysoft.com.tr'}
                                        {this.isTurcef() && ' destek@kolaysoft.com.tr'}
                                        {this.isMedikal() && 'medikal@kolaysoft.com.tr'}
                                        {this.isIsitmeMerkezi() && 'medikal@kolaysoft.com.tr'}
                                        {this.isTestud() && 'medikal@kolaysoft.com.tr'}

                                        {this.isKolaytest() && ' destek@kolaysoft.com.tr'}
                                    </p>

                                    <h4 style={{marginBottom: '5px'}}>Uzaktan Bağlantı Desteği</h4>
                                    <p>
                                        Destek Ekibinin bilgisayarınıza uzaktan bağlantı sağlayarak size daha
                                        hızlı yardımcı olabilmesi için altta verilen resimli bağlantıdan
                                        indirebileceğiniz uzaktan masaüstü bağlantı uygulamasını bilgisayarınıza
                                        kurarak, kurulum yaptıktan sonra kullanıcı numaranız (AnyDesk bağlantı
                                        adresiniz) ile çağrı merkezimize ulaşabilirsiniz.
                                        Kullanıcı numaranız (AnyDesk bağlantı adresiniz) aşağıdaki resimde
                                        işaretlenmiş kısımdadır.
                                    </p>
                                </div>

                                <Image style={{width: '180px'}} src='image/anydesk-logo.png'/>
                                <a href='https://anydesk.com' target="_blank">https://anydesk.com</a>
                                <Image style={{width: '640px'}} src='image/anydesk-sample.png'/>
                                <p>(Kurulum veya uzaktan yardım yazılımları konusunda sorun yaşıyorsanız lütfen
                                    sistem yöneticinize başvurunuz.)</p>
                            </div>
                        </Modal.Body>
                    </Modal>
                    {this.state.edefterApplicationModal &&
                    <EdefterApplicationModal
                        currentUser={this.props.currentUser}
                        edefterApplicationModal={this.state.edefterApplicationModal}
                        close={() => this.setState({edefterApplicationModal: false})}
                        cancel={() => this.setState({edefterApplicationModal: false})}
                        refresh={() => this.refreshPage()}
                        showBody={true}
                    />
                    }

                    <Modal show={false && this.state.showCreditExpireModal}
                           onHide={() => this.setState({showCreditExpireModal: false})} size="lg">
                        <Modal.Header closeButton>
                            <h2 style={{marginBottom: '20px'}}>Süre Bitişi Yaklaşan Kontörler</h2>
                        </Modal.Header>
                        <Modal.Body>
                            <div>
                                <Table paginationEnabled={false}
                                       content={this.state.creditExpireList}
                                       columns={[
                                           {
                                               Header: "Yükleme Tarihi",
                                               accessor: "",
                                               sortable: false,
                                               Cell: row => (
                                                   <label>{this.modifyDate(row[0])}</label>
                                               )
                                           },
                                           {
                                               Header: "Başlangıç Tarihi",
                                               accessor: "",
                                               sortable: false,
                                               Cell: row => (
                                                   <label>{this.modifyDate(row[1])}</label>
                                               )
                                           },
                                           {
                                               Header: "Bitiş Tarihi",
                                               accessor: "",
                                               sortable: false,
                                               Cell: row => (
                                                   <label>{this.modifyDate(row[2])}</label>
                                               )
                                           },
                                           {
                                               Header: "Kalan Süre",
                                               accessor: "",
                                               sortable: false,
                                               Cell: row => (
                                                   <label>{row[3]}</label>
                                               )
                                           },
                                           {
                                               Header: "Sıfırlanacak Kontör",
                                               accessor: "",
                                               sortable: false,
                                               Cell: row => (
                                                   <label>{0}</label>
                                               )
                                           }
                                       ]}>
                                </Table>
                            </div>
                        </Modal.Body>
                    </Modal>
                </Row>

            );
    }
}

export default Faturam24HomePage;